// Updated route config with role-based route guards
import {  Route } from "react-router";
import { all_routes } from "./all_routes";
import StudentDashboard from "../student/dashboard/studentDashboard";
import InstructorDashboard from "../Instructor/instructor-dashboard/instructorDashboard";
import StudentList from "feature-module/Instructor/student-list/studentList";
import InstructorQuiz from "../Instructor/instructor-quiz/instructorQuiz";
import InstructorQuizResult from "../Instructor/instructor-quiz-result/instructorQuizResult";
import Login from "feature-module/auth/login/login";
import Register from "../auth/register/register";
import ForgortPassword from "../auth/forgot-password/forgortPassword";
import SetPassword from "../auth/set-password/setPassword";
import Otp from "../auth/otp/otp";
import AdminLogin from "feature-module/auth/login/AdminLogin";
import PrivateRoute from "feature-module/privateRoute/PrivateRoute";
import AuthRoute from "feature-module/privateRoute/AuthRoute";
import InstructorQuizQuestions from "feature-module/Instructor/instructor-quiz-question/instructorQuizQuestions";
import ScheduleExam from "feature-module/Instructor/schedule-exam/ScheduleExam";
import QuizTest from "feature-module/student/dashboard/QuizTest";
import QuizResultNotice from "feature-module/student/dashboard/QuizResultNotice";
import ChangePassword from "feature-module/Instructor/instructor-dashboard/changePassword";
import ComingSoon from "feature-module/student/CommingSoonPage";

const routes = all_routes;

export const publicRoutes = [
  {
    path: routes.instructorDashboard,
    element: <PrivateRoute allowedRoles={["Admin"]}><InstructorDashboard /></PrivateRoute>,
    route: Route,
  },
  {
    path: routes.instructorQuiz,
    element: <PrivateRoute allowedRoles={["Admin"]}><InstructorQuiz /></PrivateRoute>,
    route: Route,
  },
    {
    path: routes.studentQuizResult,
    element: <PrivateRoute allowedRoles={["Admin", "Student"]}><QuizResultNotice /></PrivateRoute>,
    route: Route,
  },
  {
    path: `${routes.instructorQuizResult}/:id`,
    element: <PrivateRoute allowedRoles={["Admin"]}><InstructorQuizResult /></PrivateRoute>,
    route: Route,
  },
   {
    path: routes.scheduleExam,
    element: <PrivateRoute allowedRoles={["Admin"]}><ScheduleExam /></PrivateRoute>,
    route: Route,
  },
     {
    path: routes.adminStudentsList,
    element: <PrivateRoute allowedRoles={["Admin"]}><StudentList /></PrivateRoute>,
    route: Route,
  },
    {
    path: routes.changePassowrd,
    element: <PrivateRoute allowedRoles={["Admin"]}><ChangePassword/></PrivateRoute>,
    route: Route,
  },
  {
    path: `${routes.instructorQuizQuestions}/:id`,
    element: <PrivateRoute allowedRoles={["Admin"]}><InstructorQuizQuestions /></PrivateRoute>,
    route: Route,
  },
  {
    path: routes.studentDashboard,
    element: <PrivateRoute allowedRoles={["Admin", "Student"]}><StudentDashboard /></PrivateRoute>,
    route: Route,
  },
  {
    path: routes.studentQuiz,
    element: <PrivateRoute allowedRoles={["Admin", "Student"]}><QuizTest /></PrivateRoute>,
    route: Route,
  },
    {
    path: routes.adminQuizResult,
    element: <PrivateRoute allowedRoles={["Admin", "Student"]}><QuizResultNotice /></PrivateRoute>,
    route: Route,
  },
  
];

export const authRoutes = [
  {
    path: routes.login,
    element: <AuthRoute><Login /></AuthRoute>,
    route: Route,
  },
  {
    path: routes.commingSoon,
    element: <AuthRoute><ComingSoon /></AuthRoute>,
    route: Route,
  },
  {
    path: routes.adminLogin,
    element: <AuthRoute><AdminLogin /></AuthRoute>,
    route: Route,
  },
  {
    path: routes.register,
    element: <AuthRoute><Register /></AuthRoute>,
    route: Route,
  },
  {
    path: routes.forgotpassword,
    element: <AuthRoute><ForgortPassword /></AuthRoute>,
    route: Route,
  },
  {
    path: routes.setpassowrd,
    element: <AuthRoute><SetPassword /></AuthRoute>,
    route: Route,
  },
  {
    path: routes.otp,
    element: <AuthRoute><Otp /></AuthRoute>,
    route: Route,
  },

];
